import { ProductCatalogueNotificationsController } from './catalogue_notifications/product_catalogue_notifications.controller';
import { ProductCatalogueVersionsController } from './catalogue_versions/product_catalogue_versions.controller';
import { ProductCopyController } from './copy/product_copy.controller';
import { ProductCreateController } from './create/product_create.controller';
import { ProductEditController } from './edit/product_edit.controller';
import { ProductListController } from './list/product_list.controller';
import { ProductPageController } from './page/product_page.controller';
import { IControllerConstructor } from 'angular';

export const initialise = () => {
  angular.module('app.product', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components'
  ])
    .controller('ProductCatalogueNotificationsController', <IControllerConstructor>ProductCatalogueNotificationsController)
    .controller('ProductCatalogueVersionsController', <IControllerConstructor>ProductCatalogueVersionsController)
    .controller('ProductCopyController', <IControllerConstructor>ProductCopyController)
    .controller('ProductCreateController', <IControllerConstructor>ProductCreateController)
    .controller('ProductEditController', <IControllerConstructor>ProductEditController)
    .controller('ProductListController', <IControllerConstructor>ProductListController)
    .controller('ProductPageController', <IControllerConstructor>ProductPageController);
};
